var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24998 4.66092V4C8.24998 2.48122 9.4812 1.25 11 1.25H13C14.5188 1.25 15.75 2.48122 15.75 4V4.66092C16.4707 4.9104 17.1232 5.20554 17.6887 5.50064C18.3743 5.8584 18.905 6.389 19.284 7.02081C19.0903 7.17489 18.8829 7.32396 18.6623 7.46736C16.9911 8.55363 14.6378 9.25 12 9.25C9.36222 9.25 7.00883 8.55363 5.33765 7.46736C5.11704 7.32396 4.90972 7.17489 4.716 7.02081C5.09497 6.389 5.62569 5.8584 6.31125 5.50064C6.87674 5.20554 7.52933 4.9104 8.24998 4.66092ZM9.74998 4V4.24193C10.4607 4.09126 11.2152 4 12 4C12.7848 4 13.5393 4.09126 14.25 4.24193V4C14.25 3.30964 13.6904 2.75 13 2.75H11C10.3096 2.75 9.74998 3.30964 9.74998 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4798 8.72501C19.6082 8.64154 19.7339 8.55559 19.8568 8.46722C19.9524 8.88589 20 9.32103 20 9.75959V12H21C21.5523 12 22 12.4477 22 13V16C22 17.1046 21.1046 18 20 18V20C20 21.1046 19.1046 22 18 22H15V18C15 17.4477 14.5523 17 14 17H10C9.44772 17 9 17.4477 9 18V22H6C4.89543 22 4 21.1046 4 20V18C2.89543 18 2 17.1046 2 16V13C2 12.4477 2.44772 12 3 12H4V9.75959C4 9.32103 4.04755 8.88589 4.14321 8.46722C4.26606 8.55559 4.39178 8.64154 4.52019 8.72501C6.4683 9.99128 9.11492 10.75 12 10.75C14.8851 10.75 17.5317 9.99128 19.4798 8.72501Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/backpack.b7c2354e62d178b92342fef318b42326.svg";
export { ForwardRef as ReactComponent };